// Copyright 2026 The Casdoor Authors. All Rights Reserved.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

import React from "react";
import {getConsoleRedirectUri} from "../utils/index";

export function getSsoCallbackUrl(application, provider, code, idpState) {
  const stateParams = new URLSearchParams({
    application: application.name,
    provider: provider.name,
    method: "signup",
    response_type: "login",
    redirect_uri: getConsoleRedirectUri(),
  });
  const state = btoa(`${stateParams.toString()}`);
  const callbackParams = new URLSearchParams({
    code: code,
    state: state,
    idpState: idpState,
    utm_source: provider.name,
  });

  return `/callback?${callbackParams.toString()}`;
}

class SsoCallback extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      providerName: props.providerName ?? props.match?.params?.provider ?? null,
      msg: null,
    };
    this.redirecting = false;
  }

  componentDidMount() {
    this.handleApplication(this.props.application);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.application !== this.props.application) {
      this.handleApplication(this.props.application);
    }
  }

  handleApplication(application) {
    if (application === undefined || this.redirecting) {
      return;
    }

    if (application === null) {
      this.setState({msg: "Unknown application"});
      return;
    }

    const providerItem = application.providers?.find(
      (item) => item.provider?.name === this.state.providerName
    );
    const provider = providerItem?.provider;
    if (provider === undefined) {
      this.setState({
        msg: `Unknown provider name: ${this.state.providerName}`,
      });
      return;
    }

    const params = new URLSearchParams(this.props.location.search);
    const code = params.get("code") || "";
    const idpState = params.get("state") || "";
    this.redirecting = true;
    window.location.replace(
      getSsoCallbackUrl(application, provider, code, idpState)
    );
  }

  render() {
    return this.state.msg;
  }
}

export default SsoCallback;
